import { render, staticRenderFns } from "./RequestsLoader.vue?vue&type=template&id=e45470da&scoped=true&"
import script from "./RequestsLoader.vue?vue&type=script&lang=js&"
export * from "./RequestsLoader.vue?vue&type=script&lang=js&"
import style0 from "./RequestsLoader.vue?vue&type=style&index=0&id=e45470da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45470da",
  null
  
)

component.options.__file = "RequestsLoader.vue"
export default component.exports